export default "__VITE_ASSET__RoL0GsAw__"